export default "__VITE_ASSET__DH15jIln__"